const AffiliatesPreview = () => {
    
    
    return (
        <div>1</div>
    )
}

export default AffiliatesPreview;